var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderLocationWhite = function SvgHeaderLocationWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "header-location_white_svg__a",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 1.5h18v21H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#header-location_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M3 9.995C3 5.311 7.037 1.5 12 1.5s9 3.81 9 8.495c0 6.506-8.182 11.987-8.531 12.218l-.434.287-.456-.258C11.229 22.044 3 17.299 3 9.995m1.637 0c0 5.523 5.668 9.574 7.332 10.643 1.65-1.201 7.395-5.737 7.395-10.643 0-3.832-3.304-6.95-7.364-6.95s-7.363 3.118-7.363 6.95",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M9.212 9.212a2.788 2.788 0 1 1 5.576 0 2.788 2.788 0 0 1-5.576 0m4.077 0A1.29 1.29 0 0 0 12 7.924a1.29 1.29 0 0 0-1.288 1.288c0 .71.578 1.288 1.288 1.288a1.29 1.29 0 0 0 1.289-1.288",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderLocationWhite;